// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1XI_L","label":"Completed_label__8IUvu"};